var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 36600",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21564",
    d: "M21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#f74945"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21563",
    d: "m11 16 6-6",
    transform: "translate(-5 -4)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21567",
    d: "m11 16 6-6",
    transform: "rotate(90 13.5 8.5)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongRed);
export default __webpack_public_path__ + "static/media/wrong-red.3570881a4583d66ef31e5df16872b1a9.svg";
export { ForwardRef as ReactComponent };